import { render, staticRenderFns } from "./m-radio.vue?vue&type=template&id=0f20c97c&scoped=true&"
import script from "./m-radio.vue?vue&type=script&lang=js&"
export * from "./m-radio.vue?vue&type=script&lang=js&"
import style0 from "./m-radio.vue?vue&type=style&index=0&id=0f20c97c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f20c97c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
installComponents(component, {VRadio,VRadioGroup})
